import { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import PageTitle from '../../../../components/common/page-title';
import SubmissionsTable from '../../../../components/admin/submissions/list/submissions-table';
import SubmissionSearch from '../../../../components/admin/submissions/list/submissions-search';
import { getSubmissions, getSubmissionsCsv } from '../../../../actions/submissions';
import { currentUserGroup } from '../../../../utils/tokenUtils';

class SubmissionsPage extends Component {
  state = {
    outletCode: '',
    submissionType: '',
    postcodePlanObjectiveId: '',
    status: '',
    dateFrom: '',
    dateTo: '',
    auditCompleted: '',
    furtherValidationRequired: '',
    page: 1,
    auditorUser: ''
  };

  UNSAFE_componentWillMount() {
    const { dispatch, isAbm, isAuditor } = this.props;
    let status;

    if (isAbm) {
      status = 'PRE-VALIDATED';
    } else if (isAuditor) {
      status = 'PENDING';
    }

    this.setState({ status });
    dispatch(getSubmissions(null, status));
  }

  handleOutletCodeChange = (e) => {
    this.setState({ outletCode: e.target.value });
  };

  handleDateFromChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ dateFrom: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ dateFrom: '' });
    }
  };

  handleDateToChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ dateTo: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ dateTo: '' });
    }
  };

  handleAuditCompletedChange = (event) => {
    this.setState({ auditCompleted: event.target.value });
  };

  handleFurtherValidationRequiredChange = (event) => {
    this.setState({ furtherValidationRequired: event.target.value });
  }

  handleTypeChange = (event) => {
    this.setState({ submissionType: event.target.value });
  };

  handlePostcodeplanObjectiveChange = (event) => {
    this.setState({ postcodePlanObjectiveId: event.target.value });
  };

  handleStatusChange = (event) => {
    this.setState({ status: event.target.value });
  };

  handleAuditorUserChange = (event) => {
    this.setState({ auditorUser: event.target.value });
  }

  handleSearch = () => {
    const { dispatch } = this.props;
    const {
      outletCode, dateFrom, dateTo, auditCompleted, furtherValidationRequired,
      status, page, submissionType, postcodePlanObjectiveId, auditorUser
    } = this.state;

    dispatch(getSubmissions(
      outletCode,
      status,
      dateFrom,
      dateTo,
      auditCompleted,
      furtherValidationRequired,
      page,
      submissionType,
      postcodePlanObjectiveId,
      auditorUser
    ));
  };

  handleSearchButton = () => {
    this.setState({ page: 1 }, this.handleSearch);
  };

  handlePageChange = (page) => {
    this.setState({ page }, this.handleSearch);
  };

  handleClear = () => {
    this.setState({
      outletCode: '',
      status: '',
      dateFrom: '',
      dateTo: '',
      postcodePlanObjectiveId: '',
      submissionType: '',
      auditCompleted: '',
      furtherValidationRequired: '',
      auditorUser: ''
    }, this.handleSearch);
  };

  handleCsvDownload = () => {
    const {
      outletCode, dateFrom, dateTo, auditCompleted, status,
      submissionType, postcodePlanObjectiveId, auditorUser
    } = this.state;

    getSubmissionsCsv(
      outletCode,
      status,
      dateFrom,
      dateTo,
      auditCompleted,
      submissionType,
      postcodePlanObjectiveId,
      auditorUser
    );
  };

  render() {
    const {
      paging, meta, loading, submissions, isAbm
    } = this.props;
    const {
      page, status, dateFrom, dateTo, submissionType, postcodePlanObjectiveId,
      auditCompleted, outletCode,
      auditorUser, furtherValidationRequired
    } = this.state;

    const pageTitle = isAbm ? 'Price It Plus Submissions' : 'Submissions';

    return (
      <div>
        <PageTitle>{pageTitle}</PageTitle>
        {loading ? 'Loading...' : (
          <div>
            <SubmissionSearch
              postcodePlanObjectiveId={postcodePlanObjectiveId}
              submissionType={submissionType}
              status={status}
              statusTypes={meta['status-types']}
              dateFromValue={dateFrom}
              dateToValue={dateTo}
              auditCompleted={auditCompleted}
              furtherValidationRequired={furtherValidationRequired}
              outletCode={outletCode}
              postCodeplanObjectives={meta['postcodeplan-objectives']}
              auditorUser = {auditorUser}
              auditorUsers={meta['auditor-users']}
              onTypeChange={this.handleTypeChange}
              onPostcodeplanObjectiveChange={this.handlePostcodeplanObjectiveChange}
              onStatusChange={this.handleStatusChange}
              onDateFromChange={this.handleDateFromChange}
              onDateToChange={this.handleDateToChange}
              onAuditCompletedChange={this.handleAuditCompletedChange}
              onFurtherValidationRequiredChange={this.handleFurtherValidationRequiredChange}
              onOutletCodeChange={this.handleOutletCodeChange}
              onSearch={this.handleSearchButton}
              onClear={this.handleClear}
              onAuditUserChange={this.handleAuditorUserChange}
              pendings={meta['pending-count']}
            />
            <Button
              className="red-ghost-btn"
              onClick={this.handleCsvDownload}
            >
              Download submission data
            </Button>
            <SubmissionsTable
              submissions={submissions}
              currentPage={page}
              onPageChange={this.handlePageChange}
              paging={paging}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  submissions: state.submissions.submissions,
  loading: !state.submissions.fetched && state.submissions.fetching,
  meta: state.submissions.meta,
  paging: state.submissions.paging,
  isAbm: currentUserGroup() === 'abm',
  isAuditor: currentUserGroup() === 'savi_auditor'
});

export default connect(mapStateToProps)(SubmissionsPage);
